var NuisLayer;
(function(NuisLayer) {
    NuisLayer[NuisLayer["SelectIcon"] = 1] = "SelectIcon";
    NuisLayer[NuisLayer["SelectContainer"] = 100] = "SelectContainer";
    NuisLayer[NuisLayer["Header"] = 100] = "Header";
    NuisLayer[NuisLayer["TopMostLayer"] = 9999] = "TopMostLayer";
})(NuisLayer || (NuisLayer = {}));

export { NuisLayer };
